import { render, staticRenderFns } from "./community_category.vue?vue&type=template&id=01223914&scoped=true&"
import script from "./community_category.vue?vue&type=script&lang=js&"
export * from "./community_category.vue?vue&type=script&lang=js&"
import style0 from "./community_category.vue?vue&type=style&index=0&id=01223914&lang=less&scoped=true&"
import style1 from "./community_category.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01223914",
  null
  
)

export default component.exports